import { useConfigContext } from 'config/ui/ConfigContext'

import { DropdownMenu } from './DropdownMenu'
import { StyledMenuItem } from './Navigation.styles'
import { NavigationItem } from './NavigationItem'

export function Contracts() {
  const { enableShipperGuidePage } = useConfigContext()

  const hideRFP = enableShipperGuidePage.toBoolean()

  if (hideRFP) {
    return <NavigationItem title="Contracts" url="/contracts" />
  }

  return (
    <DropdownMenu title="Contracts">
      <StyledMenuItem title="Loadsmart Contracts" url="/contracts" />
      <StyledMenuItem title="Shipper RFPs" url="/rfp" />
    </DropdownMenu>
  )
}
